import NotAuthorizationPageComponent from './NotAuthorizationPageComponent';
import { useStyles } from './NotAuthorizationPageComponentStyles';
export default NotAuthorizationPageComponent;

export { useStyles };
